module.exports = __webpack_public_path__ + "img/218.f79d0a8c.png";